import VerticalLayout from './VerticalLayout';

export default VerticalLayout;
